import { ElementRef, inject, Injectable, Renderer2 } from '@angular/core';
import { ProfileSelectorDetails } from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { ProfileSelectorAdapterHelperService } from '../../data-access/adapters/profile-selector/profile-selector-adapter-helper.service';
import {
  AEM_AIR_SHOPPING,
  AEM_CONTENT,
  AEM_STATICURL,
  BAU_URLS,
  DOT_DELTA_COM,
  HOME_PAGE_URL,
  PERM_TYPE,
  WIFI_PORTAL
} from '../../data-access/constants/profile-selector/profile-selector-constants';
import { ProfileSelectorFacadeService } from '../../data-access/facades/profile-selector';
import { ProfileSelectorUtilService } from '../../data-access/utils/profile-selector/profile-selector-util.service';
@Injectable({
  providedIn: 'root'
})
export class ProfileSelectorHelperComponent {
  refreshURL = '';
  formElement!: ElementRef;

  emptyContentDetails: ProfileSelectorDetails = {} as ProfileSelectorDetails;
  emptyBusinessStateSelected = {} as {
    selectedState: boolean;
    accountIndex: number;
  };

  profileSelectorFacadeService = inject(ProfileSelectorFacadeService);
  profileSelectorAdapterHelperService = inject(
    ProfileSelectorAdapterHelperService
  );

  profileSelectorUtilService = inject(ProfileSelectorUtilService);
  renderer = inject(Renderer2);
  elementRef = inject(ElementRef);

  defaultSelectAccount(
    companyName: string,
    permType: string,
    accountIndex: number
  ): void {
    this.profileSelectorUtilService.setAccountCookie(
      companyName,
      permType,
      accountIndex
    );
  }

  selectAccount(
    companyName: string,
    permType = 'P',
    accountIndex = 0,
    displayInlineText?: string,
    isOaSmeAccount?: boolean,
    partnerId?: string,
    restrictOnePax?: boolean,
    disableMiles?: boolean
  ): void {
    this.profileSelectorFacadeService.accountSelected(
      companyName,
      permType,
      accountIndex,
      displayInlineText,
      isOaSmeAccount,
      partnerId,
      restrictOnePax,
      disableMiles
    );
    if (this.isRedirectForStandAloneHelper(permType)) {
      this.returnToOriginalPage();
    }
  }

  isRedirectForStandAloneHelper(permType: string): boolean {
    return (
      this.profileSelectorFacadeService.fromProfileStandAlone$.value &&
      permType !== PERM_TYPE.S &&
      permType !== PERM_TYPE.A
    );
  }

  returnToOriginalPage(): void {
    this.refreshURL = this.refreshURL || HOME_PAGE_URL;
    this.returnToRefreshURL();
  }

  getElementRefHelper(element: ElementRef): void {
    this.formElement = element;
  }

  returnToRefreshURL(): void {
    if (this.returnToOriginalUrl(this.refreshURL)) {
      this.formElement.nativeElement.submit();
    } else {
      window.location.href = this.refreshURL;
    }
  }

  returnToOriginalUrl(resUrl: string): boolean {
    let bauUrlCheck = false;
    let bauUrl = [];

    if (BAU_URLS) {
      bauUrl = BAU_URLS;
      bauUrl?.filter((item) => {
        if (resUrl && resUrl.includes(item)) {
          bauUrlCheck = true;
        }
      });
    }
    return bauUrlCheck;
  }

  refreshURLAvailable(): boolean {
    return (
      this.refreshURL.indexOf(AEM_CONTENT) !== -1 ||
      this.refreshURL.indexOf(AEM_STATICURL) !== -1 ||
      this.refreshURL.indexOf(AEM_AIR_SHOPPING) !== -1 ||
      this.checkForWifiUrl()
    );
  }

  checkForWifiUrl(): boolean {
    return (
      this.refreshURL?.includes(WIFI_PORTAL) &&
      this.refreshURL?.includes(DOT_DELTA_COM)
    );
  }

  modalContainerFocus(): void {
    const modalContainer = document.getElementById(
      'profile-selector-smart'
    ) as HTMLInputElement;
    modalContainer.focus();
  }
}
